import PropTypes from "prop-types";
import React from "react";
import styles from "./SidePanelButton.module.css";

const SidePanelButton = ({ width = 15, open = true, openIcon, closeIcon, onClick }) => {
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  const icon = open ? openIcon : closeIcon;

  return (
    <div
      className={styles["side-panel-button"]}
      style={{ "--width": `${width}px` }} // Passing the width as a CSS variable
    >
      <span className={`icon ${icon} ${styles["icon-style"]}`} onClick={handleClick} />
    </div>
  );
};

SidePanelButton.propTypes = {
  openIcon: PropTypes.string.isRequired,
  closeIcon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default SidePanelButton;
